import React from 'react'

import { Box, Button, Grid } from '@material-ui/core'
import { StageCard } from './components'
import { find } from 'lodash'
import helpers from 'helpers'

const StagesCard = ({ governanceProject, handleProjectManagerRedirection }) => {
  const stages = governanceProject?.governanceProjectTemplateStages
  const contestationAuditStage = find(stages, { kind: 'contestation_audit' })
  const contestationStage =
    contestationAuditStage ?? find(stages, { kind: 'contestation' })
  const auditStage = find(stages, { kind: 'audit_answers' })

  const hasFinalResult = !!contestationStage || !!auditStage

  const finalResultAvailableStatus = !!contestationStage
    ? contestationStage?.progressStatus
    : auditStage?.progressStatus

  return (
    <Box p={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <StageCard
            subtitle="Data de Início"
            title={helpers.formatters.date(governanceProject?.startDate)}
            variant="date"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StageCard
            subtitle="Data de Fim"
            title={helpers.formatters.date(governanceProject?.origin?.endDate)}
            variant="date"
          />
        </Grid>
        {stages?.map((stage) => (
          <Grid item xs={12} key={stage?.id}>
            <StageCard
              title={stage?.name}
              subtitle={stage?.description}
              status={stage?.progressStatus}
            />
          </Grid>
        ))}
        {!!hasFinalResult && (
          <Grid item xs={12} key="result">
            <StageCard
              title="Resultado Final"
              subtitle={`As ${
                !!contestationStage ? 'contestações' : 'respostas'
              } serão avaliadas e será enviado o relatório final com as notas que serão consideradas.`}
              status={
                finalResultAvailableStatus === 'completed'
                  ? 'completed'
                  : 'pending'
              }
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Button
            component="span"
            fullWidth
            color="primary"
            variant="contained"
            onClick={() =>
              handleProjectManagerRedirection(governanceProject?.id)
            }
          >
            Acompanhar
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default StagesCard
